import { RootState, useAppSelector } from 'reducers/rootReducer';
const useFormHasErrors = (formId: string) => {
    const errorCount = useAppSelector((state: RootState) => (state.form![formId] || {}).syncErrors);
    return errorCount > 0;
};
export default useFormHasErrors;
